import { render, staticRenderFns } from "./formatoSaida.vue?vue&type=template&id=4ec022c1&"
import script from "./formatoSaida.vue?vue&type=script&lang=js&"
export * from "./formatoSaida.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports